export const allSuggestions = [
    // Core information
    "Who are you?",
    "What do you do?",
    "Where are you based?",
    "What languages do you speak?",
    "How can I connect with you?",

    // Skills & Experience
    "What are your skills?",
    "What programming languages do you use?",
    "What frameworks do you prefer?",
    "What development tools do you use?",
    "What's your work history?",
    "What's your coding philosophy?",
    "What's your education?",
    "What certifications do you have?",

    // Projects & Work
    "What have you built?",
    "What kind of websites have you built?",

    // Technical Interests
    "What's your take on Web3?",
    "How do you use AI in development?",
    "What's your preferred tech stack?",
    "How do you stay updated with tech?",

    // Work Style & Environment
    "Tell me about your home office",
    "What's your daily routine?",
    "What's your preferred work environment?",

    // Community & Professional Development
    "Any community involvement?",

    // Personal Interests
    "What games do you play?",
    "What anime are you watching?",
    "What manga are you reading?",
    "What music do you listen to?",
    "Coffee or tea preferences?",
    "What's your favorite food?",
    "Any interesting hobbies?",
    "Tell me about your home projects",
    "What do you do for fun?",
    "Any interest in digital art?",
    "How do you spend your free time?"
];

export const welcomeMessage = {
    id: Date.now() + Math.random(),
    sender: "ai",
    text: [
        "Hey there! I'm fccview's personal chat assistant. I'd love to tell you all about:",
        "",
        "▹ Professional Background",
        "  • Skills and technical expertise",
        "  • Work history and experience",
        "  • Projects and achievements",
        "",
        "▹ Technical Interests",
        "  • Frontend development",
        "  • Tools and frameworks",
        "  • Open Source Involvement",
        "",
        "▹ Personal Life",
        "  • Anime and manga favorites",
        "  • Gaming and retro tech",
        "  • Music and hobbies",
        "",
        "Feel free to ask me anything or try the suggestion buttons below!",
        "Pro tip: Type '/help' to see available commands and some easter eggs!"
    ].join('\n'),
    displayText: "",
};

export const getRandomSuggestions = (count = 6) => {
    const shuffled = [...allSuggestions].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
}; 